import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateGuard } from './helpers/can-activate';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/log-in'},
  { path: 'log-in',  loadChildren: () => import('./pages/log-in/log-in.module').then( m => m.LogInModule)},
  { path: 'pages',  loadChildren: () => import('./pages/pages.module').then( m => m.PagesModule)},
  {
    path: 'transport-management-system',
    loadChildren: () => import('./pages/transport-management-system/transport-management-system.module').then(m => m.TransportManagementSystemModule),
  },{
    path: 'timeslot-booking',
    loadChildren: () => import('./pages/timeslot-booking/timeslot-booking.module').then(m => m.TimeslotBookingModule),
  },
  { path: '**', loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule) }

];
// canActivate: [CanActivateGuard],
// canActivateChild: [CanActivateGuard],
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
